import { createContext, useCallback, useContext, useEffect, useState, type ReactNode } from 'react'
import { api, type AdminMode } from './api.ts'

/**
 * Stav admin režimu. Z prohlížeče se jen čte — přepíná se tokenem z Makefile,
 * takže tu není co odemykat ani kam zadávat heslo.
 */
type Value = AdminMode & { locked: boolean; refresh: () => Promise<void> }

const AdminModeContext = createContext<Value>({ on: false, until: null, locked: true, refresh: async () => {} })

export function AdminModeProvider({ children }: { children: ReactNode }) {
  // Než dorazí odpověď, tváříme se jako zamčeno — ať správcovské odkazy
  // neproblikávají lidem, kteří na ně nemají.
  const [state, setState] = useState<AdminMode>({ on: false, until: null })

  const refresh = useCallback(async () => {
    try {
      setState(await api.adminMode())
    } catch {
      setState({ on: false, until: null })
    }
  }, [])

  useEffect(() => void refresh(), [refresh])

  return (
    <AdminModeContext.Provider value={{ ...state, locked: !state.on, refresh }}>
      {children}
    </AdminModeContext.Provider>
  )
}

export const useAdminMode = () => useContext(AdminModeContext)
